export interface IAlertState {
  show: boolean;
  title: string;
  message: string;
  type: string;
  confirmation: boolean;
  spaceId?: number;
  bookingId?: number;
  employeeId?: number;
  deleteCompanyId?: number;
  editCompanyId?: number;
  editSpaceId?: number;
  editCoworkingId?: number;
  optionOkText?: string;
  optionCancelText?: string;
  action?: string;
}

export const initialAlertState: IAlertState = {
  show: false,
  title: "",
  message: "",
  type: "alert",
  confirmation: false,
  optionOkText: "",
  optionCancelText: "",
  action: "",
};
